import { Link } from "react-router-dom";
import { useAuth, homeFor } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

export default function FeatureDisabledPage() {
  const { user } = useAuth();
  const home = user ? homeFor(user.role) : "/";
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6"
         data-testid="feature-disabled-page">
      <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-5">
        <Lock className="w-8 h-8 text-muted-foreground" strokeWidth={1.6} />
      </div>
      <h1 className="text-2xl font-display font-bold mb-2">Feature unavailable</h1>
      <p className="text-muted-foreground max-w-md mb-6">
        This feature is currently disabled by Super Admin. Existing data is
        preserved and unaffected — please contact your administrator for details.
      </p>
      <Link to={home}>
        <Button data-testid="feature-disabled-back-home">Back to dashboard</Button>
      </Link>
    </div>
  );
}
